/**
 * Checks to see if the basket key is available in the `query` object.
 * If it is not available we want to redirect to the 404 page and persist
 * the checkout url as it currently exists.
 *
 * Example: when we're not redirected `{ menu: 1234, basket: 'someId', collection: 'false' }`
 *
 * Example: when we're redirected `{ menu: 1234, collection: 'false' }`
 *
 * @param route
 * @param error
 */
const checkout = ({
    app, error, redirect, route, store
}) => {
    const { settings } = store.state.configuration;
    const { baseLoginUrl } = settings.registration;
    const { legacyCookieName } = settings.auth;
    const { isGuestCheckoutEnabled } = settings.globalCheckout.features;

    const returnUrl = encodeURIComponent(route.fullPath);
    const authCookie = app.$cookies.get(legacyCookieName);

    if (!('basket' in route.query)) {
        error({
            statusCode: 404,
            message: 'No basket parameter provided'
        });
    }

    if (!authCookie && !isGuestCheckoutEnabled) {
        redirect(`${baseLoginUrl}?returnUrl=${returnUrl}`);
    }
};

export default checkout;
